/* ==========================================================================
   NSG Framework
   Component : NSG Feelings
   Version   : 1.0
   ========================================================================== */

(() => {
  'use strict';

  const sections = document.querySelectorAll('.nsg-feelings');

  if (!sections.length) return;

  sections.forEach((section) => {

    const cards = section.querySelectorAll('.nsg-feelings__card');

    if (!cards.length) return;

    if ('IntersectionObserver' in window) {

      const observer = new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');

          observer.unobserve(entry.target);

        });

      }, {
        threshold: 0.15
      });

      cards.forEach((card, index) => {

        card.style.transitionDelay = `${index * 90}ms`;

        observer.observe(card);

      });

    } else {

      cards.forEach((card) => {
        card.classList.add('is-visible');
      });

    }

  });

})();